module.exports = __webpack_public_path__ + "static/assets/12d7b94dfed579162ee952506af11b57.jpg";